import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, Breadcrumb } from 'antd';

import { checkLogged } from '../../store/auth/authSlice'
import { sendNotify } from '../../helper'

const { confirm } = Modal;

export default function Navbar() {
  const dispatch = useDispatch()
  let details = useSelector((state) => state.auth.userDetails)

  const confirmLogout = () => {
    confirm({
      title: <h5>Confirm Logout</h5>,
      content: <p>Are you sure you want to log out?</p>,
      className: 'custom-confirm',
      centered: true,
      okText: 'Logout',
      onOk() {
        logout();
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  const logout = () => {
    sendNotify('success', "Logout successfully!")
    localStorage.clear(process.env.REACT_APP_JWT_TOKEN)
    dispatch(checkLogged())
  }

  return (
    <nav className='navbar'>
      {/* <Breadcrumb
        items={[
          {
            href: '',
            title: <i className="fal fa-home"></i>,
          },
          {
            title: 'Dashboard',
          },
        ]}
      /> */}
      <div></div>
      <div className="w-sm-100 d-flex align-items-center justify-content-between justify-content-md-start">
        <div className="profile">
          <img src="https://www.w3schools.com/w3images/avatar3.png" alt="" />
          <div className='d-flex flex-column justify-content-center ms-2'>
            <h6>{details?.name}</h6>
            <p>{details?.email}</p>
          </div>
        </div>
        <button className="nav-btn-secondary ms-md-3" onClick={confirmLogout} title="Logout"><i className="far fa-sign-out"></i></button>
      </div>
    </nav>
  )
}
